<template>
  <ElAlert effect="dark" show-icon type="warning">
    <div slot="title">
      {{ hint }}
    </div>
  </ElAlert>
</template>

<script>
export default {
  name: 'CampaignViewCpiLimitHint',
  props: {
    hasError: Boolean,
    cpiLimit: {
      type: Number,
      default: 20000,
    },
  },
  computed: {
    hint() {
      const translationKey = this.hasError
        ? 'ADVERTISEMENT.CAMPAIGN_VIEW.CPI_ERROR_LIMIT_HINT'
        : 'ADVERTISEMENT.CAMPAIGN_VIEW.CPI_LIMIT_HINT';

      return this.$t(translationKey, { limit: this.cpiLimit });
    },
  },
};
</script>
